import { render, staticRenderFns } from "./ActionButtonsDisqualified.vue?vue&type=template&id=0fc8951e"
import script from "./ActionButtonsDisqualified.vue?vue&type=script&lang=js"
export * from "./ActionButtonsDisqualified.vue?vue&type=script&lang=js"
import style0 from "./ActionButtonsDisqualified.vue?vue&type=style&index=0&id=0fc8951e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports